import * as React from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/river/h5/');

const App: React.FunctionComponent = () => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('riverportablepowerstation');

    const web1Map = {
        us: ['RIVER_M_01.webp', 'RIVER_M_01.png'],
        au: ['RIVER_M_01_au.webp', 'RIVER_M_01_au.png'],
        uk: ['RIVER_M_01_uk.webp', 'RIVER_M_01_uk.png'],
        de: ['RIVER_M_01_eu.webp', 'RIVER_M_01_eu.png'],
        fr: ['RIVER_M_01_eu.webp', 'RIVER_M_01_eu.png'],
        eu: ['RIVER_M_01_eu.webp', 'RIVER_M_01_eu.png'],
        it: ['RIVER_M_01_eu.webp', 'RIVER_M_01_eu.png'],
        es: ['RIVER_M_01_eu.webp', 'RIVER_M_01_eu.png'],
        cn: ['RIVER_M_01_cn.webp', 'RIVER_M_01_cn.png'],
        za: ['RIVER_M_01_za.webp', 'RIVER_M_01_za.png'],
        sa: ['RIVER_M_01_uk.webp', 'RIVER_M_01_uk.png'],
    };

    return (
        <>
            <section className={`river-mini-overview ${css.OverView}`}>
                <article className="grid-content">
                    <div className="view-item view-item-1">
                        <EFPic
                            name={web1Map[locale as keyof typeof web1Map] || web1Map['us']}
                            alt={t('river.ytdd_section1_tit')}
                            aria-label={t('river.ytdd_section1_tit')}
                        />
                        <span className="text">{t('river.ytdd_section1_tit')}</span>
                    </div>
                    <div className="view-item view-item-2">
                        <EFPic name={['RIVER_M_02.webp', 'RIVER_M_02.png']} alt={t('river.Capacity')} aria-label={t('river.Capacity')} />
                        <span className="text">{t('river.ytdd_section2_tit')}</span>
                        <span className="text">{t('river.ytdd_section2_special')}</span>
                    </div>
                    <div className="view-item view-item-3">
                        <EFPic
                            name={['RIVER_M_03.webp', 'RIVER_M_03.png']}
                            alt={t('river.ytdd_section5_special')}
                            aria-label={t('river.ytdd_section5_special')}
                        />
                        <span className="text">
                            <span className="txt">{t('river.ytdd_section5_tit2')}</span>
                            <span>{t('river.ytdd_section5_special')}</span>
                        </span>
                    </div>
                    <div className="view-item view-item-4">
                        <EFPic name={['RIVER_M_04.webp', 'RIVER_M_04.png']} alt={t('river.ytdd_section4_tit2')} aria-label={t('river.ytdd_section4_tit2')} />
                        <span className="text">{t('river.ytdd_section4_tit2')}</span>
                    </div>
                    <div className="view-item view-item-5">
                        <EFPic
                            name={['RIVER_M_05.webp', 'RIVER_M_05.png']}
                            alt={t('river.ytdd_section3_btm_tit3')}
                            aria-label={t('river.ytdd_section3_btm_tit3')}
                        />
                        <span className="text">
                            {t('river.ytdd_section3_btm_tit1')}
                            {'\n'}
                            {t('river.ytdd_section3_btm_tit2')}
                        </span>
                        <span className="text">{t('river.ytdd_section3_btm_tit3')}</span>
                    </div>
                    <div className="view-item view-item-6">
                        <EFPic
                            name={['RIVER_M_06.webp', 'RIVER_M_06.png']}
                            alt={t('river.ytdd_section3_top_tit')}
                            aria-label={t('river.ytdd_section3_top_tit')}
                        />
                        <span className="text">{t('river.ytdd_section3_top_tit')}</span>
                    </div>
                </article>
            </section>
        </>
    );
};

export default App;
